import React, { useState } from 'react';
import { Box, Typography, InputAdornment, IconButton } from '@mui/material';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { StyledTextField } from '../styles/StyledComponents';

const PasswordFields = ({ 
  newPassword, 
  confirmPassword, 
  passwordError,
  onNewPasswordChange,
  onConfirmPasswordChange,
  isMobile
}) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ mb: 2 }}>
        Create your password
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Please create a secure password for your account. Your password should be at least 8 characters long.
      </Typography>
      
      <StyledTextField
        fullWidth
        label="New Password"
        variant="outlined"
        type={showNewPassword ? 'text' : 'password'}
        value={newPassword}
        onChange={onNewPasswordChange}
        error={!!passwordError}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock size={18} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowNewPassword(!showNewPassword)}
                edge="end"
              >
                {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      
      <StyledTextField
        fullWidth
        label="Confirm Password"
        variant="outlined"
        type={showConfirmPassword ? 'text' : 'password'}
        value={confirmPassword}
        onChange={onConfirmPasswordChange}
        error={!!passwordError}
        helperText={passwordError}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock size={18} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                edge="end"
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Your password must be at least 8 characters long and should include a mix of letters, numbers, and special characters.
      </Typography>
    </Box>
  );
};

export default PasswordFields;